import React, { useMemo } from 'react'
import { IndexPage } from 'src/components/Reusable/IndexPage'
import { useLocation, useSearchParams } from 'react-router-dom'
import { FilterBar } from 'src/components/Reusable/IndexPage/FilterBar'
import { INDEX_PAGE_WITH_FILTERS } from 'src/components/Reusable/IndexPage/IndexPage.constants'
import { showInfoToast } from 'src/Utils/helpers/toast'
import log from 'loglevel'
import { usePaginateItemsWithNavigate } from 'src/components/Reusable/paginate/paginate.hooks'
import { PaginateButtonsGroup } from 'src/components/Reusable/paginate/PaginateButtons'
import { Service } from 'src/xgenerated/service'
import { FilterBarConfigs } from 'src/components/Reusable/IndexPage/FilterBar/FilterBar.constants'
import { useApplySearch } from 'src/Utils/search/search.hooks'
import {
  useSearchableServices,
  useServices,
  useServicesRequest,
} from '../Services.hooks'
import { getActiveServices } from '../services.helpers'
import { ServicesIndexPageActions } from '../services.components'
import { SERVICES_PAGE_SIZE } from '../Services.constants'
import { ServicesIndexGrid } from './ServicesIndexGrid'

export const ServicesIndexPage = (): JSX.Element => {
  const [searchParams] = useSearchParams()
  const pageCount = Number(searchParams.get('pc'))
  const location = useLocation()
  const req = useServicesRequest()
  const { data, isLoading, error } = useServices(req)

  if (error) {
    showInfoToast(
      "Sorry we couldn't load your services. Please refresh and try again.",
    )
    log.error('Error loading services', error)
  }

  const activeServices = useMemo(() => {
    const services = data?.getServicesList() || []
    return getActiveServices(services, location.search)
  }, [data, location.search])
  const searchableServices = useSearchableServices(activeServices)
  const { data: matchingServices } = useApplySearch(searchableServices)

  const { paginatedItems, currentPage, nextPage, prevPage } =
    usePaginateItemsWithNavigate<Service>({
      items: matchingServices,
      pageSize: pageCount > 0 ? pageCount : SERVICES_PAGE_SIZE,
    })

  return (
    <IndexPage
      title="Services"
      actions={<ServicesIndexPageActions />}
      filterBar={
        <FilterBar
          config={FilterBarConfigs[INDEX_PAGE_WITH_FILTERS.SERVICES]}
          searchBarOptions={{ withContentSearch: false }}
        />
      }
      indexGrid={
        <ServicesIndexGrid services={paginatedItems} isLoading={isLoading} />
      }
      pagination={
        <PaginateButtonsGroup
          totalItems={matchingServices.length}
          pageSize={pageCount > 0 ? pageCount : SERVICES_PAGE_SIZE}
          currentPage={currentPage}
          onPrevClick={prevPage}
          onNextClick={nextPage}
        />
      }
    />
  )
}
